import audioMps from '@/static/systemVioce/clickVioce.mp3';
import backMps from '@/static/systemVioce/backVioce.mp3';
import sendMps from '@/static/systemVioce/sendVioce.mp3';
import changeMps from '@/static/systemVioce/changeVioce.mp3';
import { usePublicStore } from '@/stores/public.js';
import { getNewVersion } from '@/requestPub/interface';
const vioceArray = {
    1: {
        src: audioMps,
        delay: 1.25
    },
    2: {
        src: audioMps,
        delay: 1.25
    },
    3: {
        src: sendMps,
        delay: 1.25
    },
    4: {
        src: changeMps,
        delay: 1.25
    },
    5: {
        src: backMps,
        delay: 1.25
    }
};

// 点击音效
export const playAudio = (typeIndex = 1) => {
    // #ifdef APP
    const bgAudioManager = uni.createInnerAudioContext();
    bgAudioManager.autoplay = true;
    bgAudioManager.src = vioceArray[typeIndex].src;
    bgAudioManager.volume = 0.3;
    bgAudioManager.onEnded(() => {
        bgAudioManager.destroy();
    });

    // #endif
};
//播报语音
export const playVoice = (url = '') => {
    // #ifdef APP
    const bgAudioManager = uni.getBackgroundAudioManager();
    bgAudioManager.src = url;
    bgAudioManager.playbackRate = 1;
    bgAudioManager.play();
    // #endif
};

// 格式化时间：接受一个时长参数（分钟），计算是多少小时多少分钟
export const formatTimes = (time) => {
    if (typeof time !== 'number' || time < 0) return '0小时0分钟';
    const hours = Math.floor(time / 60);
    const minutes = Math.floor(time % 60);
    if (hours === 0) {
        return `${minutes}小时`;
    }
    if (minutes === 0) {
        return `${hours}分钟`;
    }
    return `${hours}小时${minutes}分钟`;
};
// 格式化金额
//金额位数判断
export const formatPrice = (amount) => {
    // 转换为数字并处理无效输入
    const num = Number(amount);
    if (isNaN(num) || num < 0) {
        return '0.00';
    }
    if (num < 10000) {
        return num.toFixed(2);
    }
    const ret = Math.floor((num / 10000) * 100) / 100;
    return ret.toFixed(2) + '万';
};

export const checkSex = (idCard) => {
    // 确保输入的身份证号长度正确
    if (!idCard || idCard.length !== 18) {
        return '先生';
    }
    // 获取第17位数字
    const genderDigit = idCard.substring(16, 17);

    // 判断奇偶性
    if (genderDigit % 2 === 0) {
        return '女士';
    } else {
        return '先生';
    }
};

function compareVersion(version1, version2) {
    const arr1 = version1.split('.');
    const arr2 = version2.split('.');
    const length1 = arr1.length;
    const length2 = arr2.length;
    const minlength = Math.min(length1, length2);
    let i = 0;
    for (i; i < minlength; i++) {
        const a = parseInt(arr1[i]);
        const b = parseInt(arr2[i]);
        if (a > b) {
            return 1;
        } else if (a < b) {
            return -1;
        }
    }
    if (length1 > length2) {
        for (let j = i; j < length1; j++) {
            if (parseInt(arr1[j]) != 0) {
                return 1;
            }
        }
        return 0;
    } else if (length1 < length2) {
        for (let j = i; j < length2; j++) {
            if (parseInt(arr2[j]) != 0) {
                return -1;
            }
        }
        return 0;
    }
    return 0;
}

export const callPhoneFun = (tel = '400-23659887') => {
    // #ifdef APP
    uni.$modal({
        title: '复制电话',
        content: tel,
        confirmTxt: '复制',
        cancelTxt: '取消',
        confirm: () => {
            copyFun(tel);
        },
        cancel: () => {}
    });
    // #endif
    // #ifdef MP
    uni.makePhoneCall({
        phoneNumber: tel,
        fail(err) {
            uni.$emit('showToast', {
                title: err
            });
        }
    });
    // #endif
};

//校验身份证
export const checkIdCard = (val) => {
    return new RegExp(/^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/).test(val);
};

//富文本格式替换
export const formatText = (html) => {
    if (!html) return '';
    // 去掉<img>中style /width / height属性
    let newContent = html.replace(/<img[^>]*>/gi, (match) => {
        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
        match = match.replace(/style\s*=\s*(["'])(?:(?!\1).)*\1/gi, ''); // 去除 style=""这样的属性
        return match;
    });
    // 修改所有style里的width属性为max-width:100%
    newContent = newContent.replace(/style="[^"]+"/gi, (match) => {
        match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
        return match;
    });

    // 去掉所有<br/>标签
    newContent = newContent.replace(/<br[^>]*\/>/gi, '');
    // img标签添加style属性：max-width:100%;height:auto
    newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"');
    return newContent;
};

//手机号脱敏
export const phoneDesensitization = (phone) => {
    if (!phone) return '';
    return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
};

//校验手机号
export const checkPhone = (phone) => {
    return new RegExp(/^(1[3-9])\d{9}$/).test(phone);
};

//复制粘贴
export const copyFun = (txt) => {
    if (!txt) return;
    uni.setClipboardData({
        data: txt,
        success: function () {
            uni.$emit('showToast', {
                title: '复制成功',
                type: 'success'
            });
        },
        fail(err) {
            console.log(err);
        }
    });
};

//序列化参数
export const querySerialization = (obj = {}) => {
    if (JSON.stringify(obj) == '{}') return '';
    let querys = '';
    Object.keys(obj).map((keys, val) => {
        if (obj[keys] != null) {
            querys += `${keys}=${obj[keys]}&`;
        }
    });
    return '?' + (querys ? querys.substr(0, querys.length - 1) : '');
};

//校验是否在内的授权信息
export const checkAuth = async (authtype) => {
    const { authSetting } = await uni.getSetting();
    return authSetting[authtype];
};

//麦克风权限
export const getMicrophone = () => {
    // 仅在 App 中执行
    // #ifdef APP
    return new Promise((resolve) => {
        plus.android.requestPermissions(
            ['android.permission.RECORD_AUDIO'],
            function (resultObj) {
                const result = resultObj.granted;
                if (result.includes('android.permission.RECORD_AUDIO')) {
                    resolve();
                } else {
                    console.warn('用户拒绝了录音权限');
                    resolve();
                    // uni.showModal({
                    //   title: '提示',
                    //   content: '请前往设置开启麦克风权限',
                    //   success(res) {
                    //     if (res.confirm) {
                    //       plus.runtime.openAppSettings();
                    //     }
                    //   }
                    // });
                }
            },
            function (error) {
                resolve();
                console.error('权限请求错误：' + JSON.stringify(error));
            }
        );
    });
    // #endif
};

export const jumpPages = async (url) => {
    uni.navigateTo({
        url
    });
};

export const jumpRePages = async (url) => {
    const currentPath = getCurrentPages();
    const currentPage = currentPath[currentPath.length - 1];
    const currentPageUrl = currentPage?.route;
    if (currentPageUrl == url) {
        return;
    }
    uni.redirectTo({
        url
    });
};

export const jumpTabPages = async (url) => {
    uni.reLaunch({
        url
    });
};

export const toLogin = () => {
    const urls = getCurrentPages()[0].route;
    uni.navigateTo({
        url: `/pages/login?url=${encodeURIComponent(urls)}`
    });
};

// 单位转化
export const toNumberUnit = (num) => {
    if (Number.isNaN(num) || !num) return 0;
    if (num < 10000 && num >= 1000) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 添加千分位分隔符
    } else if (num < 1000) {
        return num;
    } else {
        let scaledNum = num / 10000; // 将数字转换为以“万”为单位
        // return `${scaledNum.toFixed(1)}万`; // 保留一位小数
        scaledNum = scaledNum.toFixed(4);
        return `${scaledNum.split('.')[0]}.${scaledNum.split('.')[1].substr(0, 2)}万`; // 保留一位小数
    }
};

//保留3位取小数点后2位
export const toNumber = (num) => {
    if (!num) return '';
    num = num.toString();
    if (num.indexOf('.') >= 0) {
        return `${num.split('.')[0]}.${num.split('.')[1].substr(0, 2)}`; // 保留一位小数
    }
    return num;
};

//千分位
export const percentileNum = (num) => {
    const parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
};

//图片预览
export const previewImages = (imgs = []) => {
    if (!imgs.length) return false;
    uni.previewImage({
        urls: imgs,
        indicator: 'dot',
        loop: true
    });
};

//防抖
const debounceTimer = null;
export function debounceFun(fn, delay = 500) {
    let timer = null;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
}

export const isScreenLocked = () => {
    if (typeof plus !== 'undefined') {
        const pm = plus.android.runtimeMainActivity().getSystemService(plus.android.android.content.Context.KEYGUARD_SERVICE);
        return plus.android.invoke(pm, 'inKeyguardRestrictedInputMode');
    }
    return false;
};

export const getImageCache = function (filePath) {
    // 图片缓存key值
    const storageKey = 'IMAGE_CACHE_INFO_' + filePath;
    // 首先获取本地存储的数据，查询是否有对应文件路径，如果有缓存内容，直接返回
    const cacheFileInfo = uni.getStorageSync(storageKey);
    if (cacheFileInfo) {
        return cacheFileInfo;
    } else {
        // 如果没有，执行下载，并存储起来后
        uni.downloadFile({
            url: filePath,
            success: (res) => {
                if (res.statusCode === 200) {
                    // 再进行本地保存
                    uni.saveFile({
                        tempFilePath: res.tempFilePath,
                        success: function (res2) {
                            const filePath_download = plus.io.convertLocalFileSystemURL(res2.savedFilePath);
                            uni.setStorageSync(storageKey, filePath_download);
                            return filePath_download;
                        },
                        fail: function (res2) {
                            return filePath;
                        }
                    });
                } else {
                    return filePath;
                }
            },
            fail: (res) => {
                return filePath;
            }
        });
        return filePath;
    }
};

// 登录时间转换
export const parseExpiredAt = (str) => {
    if (!str) return 0;
    const t = new Date(String(str).replace(/-/g, '/')).getTime();
    return Number.isNaN(t) ? 0 : t;
};

// 判断token有效期
export const isTokenValid = () => {
    const token = uni.getStorageSync('shop_token');
    const expiredAtStr = uni.getStorageSync('token_expired_at');
    const expiredAt = parseExpiredAt(expiredAtStr);
    if (!token || !expiredAt) return false;
    return Date.now() < expiredAt - 3000;
};

export const getWriteFileManage = () => {
    // 仅在 App 中执行
    // #ifdef APP
    return new Promise((resolve) => {
        console.log('获取文件权限');
        plus.android.requestPermissions(
            ['android.permission.WRITE_EXTERNAL_STORAGE'],
            function (resultObj) {
                const result = resultObj.granted;
                console.log(result, '文件写权限');
                if (result.includes('android.permission.WRITE_EXTERNAL_STORAGE')) {
                    resolve();
                } else {
                    console.log('拒绝了写权限');
                    resolve();
                    // uni.showModal({
                    //   title: '提示',
                    //   content: '请前往设置开启麦克风权限',
                    //   success(res) {
                    //     if (res.confirm) {
                    //       plus.runtime.openAppSettings();
                    //     }
                    //   }
                    // });
                }
            },
            function (error) {
                resolve();
                console.log('写权限请求错误', JSON.stringify(error));
            }
        );
    });
    // #endif
};
export const getReadFileManage = () => {
    // 仅在 App 中执行
    // #ifdef APP
    return new Promise((resolve) => {
        console.log('获取文件读权限');
        plus.android.requestPermissions(
            ['android.permission.READ_EXTERNAL_STORAGE'],
            function (resultObj) {
                const result = resultObj.granted;
                console.log(result, '文件读权限');
                if (result.includes('android.permission.READ_EXTERNAL_STORAGE')) {
                    resolve();
                } else {
                    console.log('拒绝了读权限');
                    resolve();
                }
            },
            function (error) {
                resolve();
                console.error('权限请求错误：' + JSON.stringify(error));
            }
        );
    });
    // #endif
};

//查找会员枚举
export const getMemberText = (type, value) => {
    if (!type && !value) {
        return '-';
    }
    const pubStore = usePublicStore();
    const label = pubStore.memerEnum[type]?.find((e) => e.value == value)?.label;
    return label;
};
// 获取设备网络
export const getNetworkInfo = () => {
    return new Promise((resolve, reject) => {
        let networkType = '';
        uni.getNetworkType({
            success: function (res) {
                networkType = res.networkType;
                console.log(res.networkType);
                // 返回网络类型 networkType
                // wifi/2g/3g/4g/5g/unknown(Android下不常见的网络类型)/none(无网络)
                if (networkType == 'wifi') {
                    uni.startWifi({
                        success: function () {
                            uni.getConnectedWifi({
                                success: function (info) {
                                    resolve({
                                        type: networkType,
                                        wifi_info: info.wifi
                                    });
                                },
                                fail() {
                                    reject({
                                        type: networkType,
                                        wifi_info: null
                                    });
                                }
                            });
                        },
                        fail() {
                            reject({
                                type: networkType,
                                wifi_info: null
                            });
                        }
                    });
                } else {
                    resolve({
                        type: networkType,
                        wifi_info: null
                    });
                }
            }
        });
    });
};

const systemInfo = uni.getSystemInfoSync();
const appId = systemInfo.appId;
const appVersion = systemInfo.appVersion;
const appWgtVersion = systemInfo.appWgtVersion;
console.log('appId:', appId, 'APPVersion：', appVersion, 'appWgtVersion:', appWgtVersion);

// 检测更新实现
export const checkVersion = async () => {
    return new Promise(async (resolve, reject) => {
        const currentPath = getCurrentPages();
        const currentPage = currentPath[currentPath.length - 1];
        const url = currentPage?.route;
        console.log('当前页面：======================', url);
        if (url != 'pages/update') {
            try {
                uni.showLoading({ title: '检查中...' });
                const res = await getNewVersion({
                    app_id: appId,
                    system_type: 1,
                    version: appWgtVersion,
                    version_base: appVersion
                    // version_base: '1.0.0',
                });
                uni.hideLoading();
                const update_info = res.data;
                if (update_info) {
                    if (compareVersion(update_info?.version, appWgtVersion || '1.0.0') == 1) {
                        // 检测到更新
                        setTimeout(() => {
                            console.log('跳转更新页面================');
                            uni.navigateTo({
                                url: '/pages/update?data=' + JSON.stringify(update_info)
                            });
                        }, 600);
                        resolve({ hasUpdate: true });
                    } else {
                        uni.$emit('showToast', {
                            title: '已是最新版本',
                            type: 'none'
                        });
                        resolve({ hasUpdate: false });
                    }
                } else {
                    resolve({ hasUpdate: false });
                }
            } catch (error) {
                console.log('更新错误捕获=====>', error);
                resolve({ hasUpdate: false });
            }
        } else {
            resolve({ hasUpdate: false });
        }
    });
};

// 下载更新文件
export const downloadUpdate = (update_info) => {
    let filename = '';
    if (update_info?.appName) {
        filename = `${update_info.appName}.apk`;
    } else {
        filename = update_info.file_path.includes('apk') ? `cashier_${update_info.version}.apk` : `cashier_${update_info.version}.wgt`;
    }
    uni.getFileInfo({
        filePath: plus.io.convertLocalFileSystemURL(`file://storage/emulated/0/Download/${filename}`),
        success(res) {
            const fileSaveUrl = plus.io.convertLocalFileSystemURL(`file://storage/emulated/0/Download/${filename}`);
            if (res.digest == update_info?.file_md5.toUpperCase()) {
                uni.$emit('showToast', {
                    title: '新资源包更新中',
                    type: 'none'
                });
                uni.$emit('downloadprecess', 100);
                uni.setStorageSync('fileSaveUrl', fileSaveUrl);
                cusInstall(fileSaveUrl, update_info);
            } else {
                download(update_info, filename);
            }
        },
        fail(err) {
            download(update_info, filename);
        }
    });
};

let downloader = null;
const download = (update_info, filename) => {
    // #ifdef APP
    const { file_path: url } = update_info;
    downloader = plus.downloader.createDownload(
        url,
        {
            filename: `file://storage/emulated/0/Download/${filename}`,
            timeout: 5,
            retry: 3,
            retryInterval: 10
        },
        (d, status) => {
            if (status == 200) {
                const fileSaveUrl = plus.io.convertLocalFileSystemURL(d.filename);

                downloader = null;
                uni.$emit('showToast', {
                    title: '下载完成，新资源包更新中',
                    type: 'none'
                });
                uni.setStorageSync('fileSaveUrl', fileSaveUrl);
                cusInstall(fileSaveUrl, update_info);
            } else {
                plus.downloader.clear(); // 清除下载任务
                downloader = null;
            }
        }
    );
    if (!downloader) {
        downloader = null;
        throw new Error('下载器初始化失败');
    }
    let downloadprocess = 0;
    downloader.addEventListener('statechanged', (v) => {
        console.log('下载状态：' + v.state);
        switch (v.state) {
            case 0:
                uni.$emit('downloadprecess', 'connect');
                break;
            case 1:
                uni.$emit('downloadprecess', 'connect');
                break;
            case 2:
                uni.$emit('downloadprecess', 'ready');
                break;
            case 3:
                const score = Number((v.downloadedSize / v.totalSize) * 100).toFixed(0);
                if (downloadprocess != score) {
                    uni.$emit('downloadprecess', score);
                }
                downloadprocess = score;
                break;
            case 4:
                console.log('连接断开', v.downloadedSize == v.totalSize);
                plus.downloader.clear();
                downloader = null;
                uni.$emit('downloadprecess', v.downloadedSize == 0 ? 'connect_break' : v.downloadedSize == v.totalSize ? 100 : 'connect_break');
                break;
            case 5:
                plus.downloader.clear();
                downloader = null;
                uni.$emit('downloadprecess', 'pause');
                break;
        }
    });
    downloader.start();
    // #endif
};
export const cusInstall = (tempFilePath, downloadInfo = {}) => {
    console.log('开始安装======', tempFilePath);
    plus.runtime.install(
        tempFilePath,
        {
            force: true
        },
        (res) => {
            if (!tempFilePath.includes('apk')) {
                uni.$emit('showToast', {
                    title: '更新安装完成，即将重启',
                    type: 'none',
                    success() {
                        setTimeout(() => {
                            plus.runtime.restart();
                        }, 2000);
                    }
                });
            } else {
                console.log('更新失败', res);
            }
        },
        (err) => {
            console.log(err);
        }
    );
};
